module.exports = __webpack_public_path__ + "img/8.902f60f9.png";